import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { noop } from 'ui-components/default-props/noop';

import style from './cover.module.less';

const Cover = ({ children, allowClickEvents = false, isDisabled = false, onClick = noop, isLeft = false, isRight = false }) => {
  const styleClasses = classnames(
    { [style.cover]: isDisabled },
    { [style.enabled]: allowClickEvents },
    { [style['base-left']]: isLeft },
    { [style['base-right']]: isRight },
  );
  return (
    <div className={styleClasses} onClick={onClick}>
      {children}
    </div>
  );
};

Cover.propTypes = {
  children: PropTypes.node.isRequired,
  allowClickEvents: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  isLeft: PropTypes.bool,
  isRight: PropTypes.bool,
};

export default Cover;
